import { Avatar } from "@components/ui/Avatar"
import { professorGreetingName } from "@lib/professorName"
import { memo } from "react"
import { useTranslation } from "react-i18next"

import type { Professor } from "@/types"

interface Props {
  professor: Professor
}

export const HomeHeader = memo(function HomeHeader({ professor }: Props) {
  const { t } = useTranslation("home")
  return (
    <header className="flex items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-3">
        <Avatar
          name={professor.full_name || professor.name}
          color={professor.color}
          initials={professor.initials}
          size="md"
        />
        <div className="min-w-0">
          <h1 className="text-ink truncate text-xl font-semibold">
            {t("greeting", { name: professorGreetingName(professor, t("honorific")) })}
          </h1>
          <p className="text-meta truncate">
            {professor.school?.name ?? ""} ·{" "}
            {t("subtitle.semester", { semester: professor.semester })}
          </p>
        </div>
      </div>
    </header>
  )
})
